import store from '../../../../../resources/js/store'
import apiService from './apiService'

export default function () {
  const Vue = window.vue

  /**
   * Был загружен список всех проектов. Функционал на время разработки.
   *
   * @deprecated
   */
  Vue.$on('projectsLoaded', () => {
    const selectedClientId = localStorage.getItem('selectedClientId')

    store.dispatch('seo/projects/changeSelectedClientId', selectedClientId || null)
  })

  /**
   * Был выбран клиент. Функционал на время разработки.
   */
  Vue.$on('clientIdSelected', () => {
    store.dispatch('seo/client/domains/fetch')
    store.dispatch('seo/client/unpaidDomains/fetch')
  })

  /**
   * Был загружен список доменов клиента.
   * Если домен еще не выбран - выбираем первый из списка всех доменов.
   */
  Vue.$on('clientDomainsLoaded', () => {
    if (store.state.seo.client.domains.domains.length) {
      store.dispatch('seo/client/domains/changeSelected', store.state.seo.client.domains.domains[0])
    }
  })

  /**
   * Был выбран домен.
   */
  Vue.$on('clientDomainsSelectedChange', () => {
    // store.dispatch('manager/fetch', store.state.seo.client.domains.selected)
    // deprecated
    // store.dispatch('seo/project/services/fetchConnected', store.state.seo.client.domains.selected)
    store.dispatch('seo/client/projects/fetch', store.state.seo.client.domains.selected)
    store.dispatch('seo/client/info/fetch')
    store.dispatch('seo/existenceNewReports/fetch', store.state.seo.client.domains.selected)
    store.dispatch('seo/project/goodNews/fetchRead')

    if (store.state.module === 'seo') {
      store.dispatch('manager/fetch', 'seo')
    }
  })

  /**
   * Загружены данные по клиенту.
   */
  Vue.$on('clientInfoLoaded', () => {
    store.dispatch('seo/forms/interview/fetch', store.state.seo.client.domains.selected)
  })

  /**
   * Был загружен список проектов домена клиента.
   * Если проект еще не выбран - выбираем первый из списка всех проектов.
   */
  Vue.$on('clientProjectsLoaded', () => {
    store.dispatch('seo/client/projects/changeSelectedProjectId', store.state.seo.client.projects.projects[0].id_parent)
  })

  /**
   * Был загружен статус прочтения "хороших новостей" для последнего завершенного апдейта.
   * Если не прочитаны, загружаем данные для отображения.
   */
  Vue.$on('goodNewsReadLoaded', () => {
    for (const section in store.state.seo.project.goodNews.read) {
      if (store.state.seo.project.goodNews.read[section] === false) {
        store.dispatch('seo/project/goodNews/fetch')

        break
      }
    }
  })

  /**
   * Загружены данные по анкетированию. Нужно показать модальное окно.
   */
  Vue.$on('formsInterviewLoaded', () => {
    if (store.state.seo.client.info.client.login !== 'demo' && store.state.seo.forms.interview.interview.show_status) {
      $(`#${Vue.$getConst('INTERVIEW_MODAL_ID')}`).modal('show')

      apiService.postFormsPackageAccepted(
        store.state.seo.client.domains.selected,
        'interview',
        {
          vote_id: store.state.seo.forms.interview.interview.id
        }
      )
    }
  })

  if (process.env.VUE_APP_ENV === 'production') {
    Vue.$emit('clientIdSelected')
  } else {
    Vue.$store.dispatch('seo/projects/fetch')
  }
}
